/**
 * ToolLibraryApi
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export const AccountModuleEnumsUserOnboardingStatusDto = {
  Invited: 'Invited',
  MeasurementSystemStep: 'MeasurementSystemStep',
  DataPreferenceStep: 'DataPreferenceStep',
  TeamManagementStep: 'TeamManagementStep',
  Onboarded: 'Onboarded',
} as const;

export type AccountModuleEnumsUserOnboardingStatusDto =
  (typeof AccountModuleEnumsUserOnboardingStatusDto)[keyof typeof AccountModuleEnumsUserOnboardingStatusDto];
